import React, { Component } from "react";
import ProfileCard from "../../Components/Home/ProfileCard";
import HomeCard from "../../Components/Home/HomeCard";
import Header from "../../Components/MainLayout/Header";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import HomeWorkIcon from "../../Assets/img/home-page.png";
import OnlineClassIcon from "../../Assets/img/video-conference.png";
import GalleryIcon from "../../Assets/img/stack-of-photos.png";
import ComplaintIcon from "../../Assets/img/box-important.png";
import PaymentIcon from "../../Assets/img/check.png";
import EventIcon from "../../Assets/img/planner.png";
import HolidayIcon from "../../Assets/img/beach-umbrella.png";
import NotificationIcon from "../../Assets/img/appointment-reminders.png";
import Axios from "axios";
import Cover from "../../Assets/img/default-cover-image.svg";
import Authorize from "../../../global/Authorize";
import AttendanceIcon from "../../Assets/img/edit-property.png";
import results from "../../Assets/img/results.png";
import download from "../../Assets/img/download.png";
import BirthdayCard from "../../Components/Birthday/BirthdayCard";
import Skeleton from "react-loading-skeleton";
import schedule from "../../Assets/img/schedule.png";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class Home extends Component {
  constructor(props) {
    super(props);

    var today = new Date(),
      date =
        today.getFullYear() +
        "-" +
        ("0" + (today.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + today.getDate()).slice(-2);

    this.state = {
      UpcomingEventData: [],
      loading: true,
      todayDate: date,
      fakeData: [1, 2, 3],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Home";

    var dt = new Date();

    this.fetchUpcomingEventData({
      school: this.props.user?.user?.school?.id,
      status: true,
      from_date__gte:
        dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate(),
      session: this.props?.user?.student_info?.session?.id,
    });
  }

  fetchUpcomingEventData = (params = {}) => {
    Axios.get("/mApiV1/EventsList", { params: { ...params } })
      .then((res) => {
        this.setState({ UpcomingEventData: res.data });
        this.setState({ loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };

  render() {
    console.log(this, "this.props");
    const handelDt = (dt) => {
      var j = dt % 10,
        k = dt % 100;
      if (j === 1 && k !== 11) {
        return dt + "st";
      }
      if (j === 2 && k !== 12) {
        return dt + "nd";
      }
      if (j === 3 && k !== 13) {
        return dt + "rd";
      }
      return dt + "th";
    };
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    const handleDate = (date1, date2) => {
      let year1 = new Date(date1).getFullYear();
      let month1 = new Date(date1).getMonth();
      let dt1 = new Date(date1).getDate();

      let year2 = new Date(date2).getFullYear();
      let month2 = new Date(date2).getMonth();
      let dt2 = new Date(date2).getDate();

      year1 = year1 % 100;
      year2 = year2 % 100;
      if (year1 === year2) {
        if (month1 === month2) {
          if (dt1 === dt2) {
            return `${handelDt(dt1)} ${monthNames[month1]}, ${year1}`;
          } else {
            return `${handelDt(dt1)}-${handelDt(dt2)} ${
              monthNames[month1]
            }, ${year1}`;
          }
        } else {
          return `${handelDt(dt1)} ${monthNames[month1]} - ${handelDt(dt2)} ${
            monthNames[month2]
          }, ${year1}`;
        }
      } else {
        return `${handelDt(dt1)} ${monthNames[month1]}  ${year1} - ${handelDt(
          dt2
        )} ${monthNames[month2]}, ${year2}`;
      }
    };
    if (this.props.user.role.id !== 9) {
      return <Redirect to={"/teacherhome"} />;
    }
    return (
      <Authorize roles={["IS_STUDENT"]} redirect to="/login">
        <Header title="Home" />

        <ProfileCard />

        {this.props.user.studentData.date_of_birth ? (
          this.state.todayDate.slice(-5) ===
          this.props.user.studentData.date_of_birth.slice(-5) ? (
            <div className="px-3 pb-3">
              <BirthdayCard name={this.props.user.user.first_name} />
            </div>
          ) : null
        ) : null}

        <>
          <div className="container">
            {this.state.loading ? <Skeleton width={150} /> : null}

            {this.state.UpcomingEventData.length !== 0 &&
            this.state.loading === false ? (
              <h5 className="th-16">Upcoming Events</h5>
            ) : null}
          </div>
          <div
            className="d-flex flex-row th-no-scroll"
            style={{ overflowX: "scroll" }}
          >
            {this.state.loading ? (
              <>
                {this.state.fakeData?.map((item, index) => (
                  <div key={index}>
                    <Skeleton
                      className="ml-3 overflow-hidden"
                      height={180}
                      width={240}
                      style={{ lineHeight: 1.5, borderRadius: 16 }}
                    />
                  </div>
                ))}
                <div className="px-2"></div>
              </>
            ) : (
              <>
                {this.state.UpcomingEventData?.map((item, index) => (
                  <div key={index}>
                    <div
                      className="ml-3 overflow-hidden"
                      style={{
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",

                        backgroundImage: `url(${
                          item.event_image ? item.event_image : Cover
                        })`,
                        borderRadius: 16,
                      }}
                    >
                      <div
                        className="d-flex align-items-end"
                        style={{
                          height: 180,
                          minWidth: 240,
                          width: 240,
                          padding: 16,
                          background:
                            "linear-gradient(360deg, rgba(0, 0, 0, 0.81) 0%, rgba(0, 0, 0, 0.400781) 31.77%, rgba(0, 0, 0, 0) 100%)",
                        }}
                      >
                        <div className="">
                          <h6
                            className="th-14 mb-0 text-white"
                            style={{ width: 180 }}
                          >
                            {item.event_name}
                          </h6>
                          <p
                            className="th-12 text-truncate mb-0 text-light"
                            style={{ width: 208 }}
                          >
                            {handleDate(item.from_date, item.to_date)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="px-2"></div>
              </>
            )}
          </div>
        </>

        <div className="container py-4">
          <h5 className="th-16">Explore</h5>
          <div className="row px-2">
            <div className="col-4 px-2">
              <HomeCard
                title="Home Work"
                to="/homeWork"
                iconImage={HomeWorkIcon}
              />
            </div>
            <div className="col-4 px-2">
              <HomeCard
                title="Online Class"
                to="/onlineclass"
                iconImage={OnlineClassIcon}
              />
            </div>
            <div className="col-4 px-2">
              <HomeCard title="Gallery" to="/gallery" iconImage={GalleryIcon} />
            </div>
            <div className="col-4 px-2">
              <HomeCard title="Events" to="/events" iconImage={EventIcon} />
            </div>
            <div className="col-4 px-2">
              <HomeCard
                title="Holidays"
                to="/holidays"
                iconImage={HolidayIcon}
              />
            </div>
            <div className="col-4 px-2">
              <HomeCard
                title="Notifications"
                to="/notifications"
                iconImage={NotificationIcon}
              />
            </div>
            <div className="col-4 px-2">
              <HomeCard
                title="Payments"
                to="/payments"
                iconImage={PaymentIcon}
              />
            </div>
            <div className="col-4 px-2">
              <HomeCard
                title="Complaints"
                to="/prevComplaint"
                iconImage={ComplaintIcon}
              />
            </div>
            <div className="col-4 px-2">
              <HomeCard
                title="Attendance"
                to="/attstudent"
                iconImage={AttendanceIcon}
              />
            </div>
            <div className="col-4 px-2">
              <HomeCard
                title="Academic Downloads"
                to="/downloads"
                iconImage={download}
              />
            </div>
            <div className="col-4 px-2">
              <HomeCard title="Results" to="/results" iconImage={results} />
            </div>
            <div className="col-4 px-2">
              <HomeCard
                title="Exam Schedule"
                to="/examSchedule"
                iconImage={schedule}
              />
            </div>
            <div className="col-4 px-2">
              <HomeCard
                title="Online Exam"
                to="/exam-questions"
                iconImage={results}
              />
            </div>
            {/* <div className="col-4 px-2">
              <HomeCard title="Live Class" to="/liveClass" iconImage={Lclass} />
            </div> */}
          </div>
        </div>
      </Authorize>
    );
  }
}
export default connect(mapStateToProps)(Home);
